"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var HYPERWALLET_VALID_COUNTRIES = exports.HYPERWALLET_VALID_COUNTRIES = [{
  name: "Aland Islands",
  code: "AX",
  MinLimitUSD: 0,
  MaxLimitUSD: 50000
}, {
  name: "American Samoa",
  code: "AS",
  MinLimitUSD: 0,
  MaxLimitUSD: 50000
}, {
  name: "Andorra",
  code: "AD",
  MinLimitUSD: 0,
  MaxLimitUSD: 50000
}, {
  name: "Argentina",
  code: "AR",
  MinLimitUSD: 0,
  MaxLimitUSD: 15000
}, {
  name: "Australia",
  code: "AU",
  MinLimitUSD: 0,
  MaxLimitUSD: 50000
}, {
  name: "Austria",
  code: "AT",
  MinLimitUSD: 0,
  MaxLimitUSD: 50000
}, {
  name: "Bangladesh",
  code: "BD",
  MinLimitUSD: 0.42,
  MaxLimitUSD: 1673.9
}, {
  name: "Belgium",
  code: "BE",
  MinLimitUSD: 0,
  MaxLimitUSD: 50000
}, {
  name: "Brazil",
  code: "BR",
  MinLimitUSD: 0,
  MaxLimitUSD: 50000
}, {
  name: "Canada",
  code: "CA",
  MinLimitUSD: 0,
  MaxLimitUSD: 50000
}, {
  name: "Christmas Island",
  code: "CX",
  MinLimitUSD: 0,
  MaxLimitUSD: 50000
}, {
  name: "Cocos (Keeling) Islands",
  code: "CC",
  MinLimitUSD: 0,
  MaxLimitUSD: 50000
}, {
  name: "Colombia",
  code: "CO",
  MinLimitUSD: 0,
  MaxLimitUSD: 15000
}, {
  name: "Croatia",
  code: "HR",
  MinLimitUSD: 0,
  MaxLimitUSD: 50000
}, {
  name: "Cyprus",
  code: "CY",
  MinLimitUSD: 0,
  MaxLimitUSD: 50000
}, {
  name: "Denmark",
  code: "DK",
  MinLimitUSD: 0,
  MaxLimitUSD: 50000
}, {
  name: "Dominican Republic",
  code: "DO",
  MinLimitUSD: 0.017,
  MaxLimitUSD: 50000
}, {
  name: "Estonia",
  code: "EE",
  MinLimitUSD: 0,
  MaxLimitUSD: 50000
}, {
  name: "Faroe Islands",
  code: "FO",
  MinLimitUSD: 0,
  MaxLimitUSD: 50000
}, {
  name: "Finland",
  code: "FI",
  MinLimitUSD: 0,
  MaxLimitUSD: 50000
}, {
  name: "France",
  code: "FR",
  MinLimitUSD: 0,
  MaxLimitUSD: 50000
}, {
  name: "French Guiana1",
  code: "GF",
  MinLimitUSD: 0,
  MaxLimitUSD: 50000
}, {
  name: "Germany",
  code: "DE",
  MinLimitUSD: 0,
  MaxLimitUSD: 50000
}, {
  name: "Gibraltar",
  code: "GI",
  MinLimitUSD: 0,
  MaxLimitUSD: 50000
}, {
  name: "Greece",
  code: "GR",
  MinLimitUSD: 0,
  MaxLimitUSD: 50000
}, {
  name: "Greenland",
  code: "GL",
  MinLimitUSD: 0,
  MaxLimitUSD: 50000
}, {
  name: "Guam",
  code: "GU",
  MinLimitUSD: 0,
  MaxLimitUSD: 50000
}, {
  name: "Guadeloupe",
  code: "GP",
  MinLimitUSD: 0,
  MaxLimitUSD: 50000
}, {
  name: "Guernsey",
  code: "GG",
  MinLimitUSD: 0,
  MaxLimitUSD: 50000
}, {
  name: "Hong Kong",
  code: "HK",
  MinLimitUSD: 0,
  MaxLimitUSD: 50000
}, {
  name: "Iceland",
  code: "IS",
  MinLimitUSD: 0,
  MaxLimitUSD: 50000
}, {
  name: "Hungary",
  code: "HU",
  MinLimitUSD: 0,
  MaxLimitUSD: 50000
}, {
  name: "India",
  code: "IN",
  MinLimitUSD: 0,
  MaxLimitUSD: 50000
}, {
  name: "Indonesia",
  code: "ID",
  MinLimitUSD: 0.64,
  MaxLimitUSD: 31431
}, {
  name: "Ireland",
  code: "IE",
  MinLimitUSD: 0,
  MaxLimitUSD: 50000
}, {
  name: "Isle of Man",
  code: "IM",
  MinLimitUSD: 0,
  MaxLimitUSD: 50000
}, {
  name: "Israel",
  code: "IL",
  MinLimitUSD: 0,
  MaxLimitUSD: 266211
}, {
  name: "Italy",
  code: "IT",
  MinLimitUSD: 0,
  MaxLimitUSD: 50000
}, {
  name: "Jamaica",
  code: "JM",
  MinLimitUSD: 0,
  MaxLimitUSD: 50000
}, {
  name: "Japan",
  code: "JP",
  MinLimitUSD: 0,
  MaxLimitUSD: 50000
}, {
  name: "Jersey",
  code: "JE",
  MinLimitUSD: 0,
  MaxLimitUSD: 50000
}, {
  name: "Latvia",
  code: "LV",
  MinLimitUSD: 0,
  MaxLimitUSD: 50000
}, {
  name: "Liechtenstein",
  code: "LI",
  MinLimitUSD: 0,
  MaxLimitUSD: 50000
}, {
  name: "Lithuania",
  code: "LT",
  MinLimitUSD: 0,
  MaxLimitUSD: 50000
}, {
  name: "Luxembourg",
  code: "LU",
  MinLimitUSD: 0,
  MaxLimitUSD: 50000
}, {
  name: "Malaysia",
  code: "MY",
  MinLimitUSD: 0.23,
  MaxLimitUSD: 232786
}, {
  name: "Malta",
  code: "MT",
  MinLimitUSD: 0,
  MaxLimitUSD: 50000
}, {
  name: "Martinique",
  code: "MQ",
  MinLimitUSD: 0,
  MaxLimitUSD: 50000
}, {
  name: "Mayotte",
  code: "YT",
  MinLimitUSD: 0,
  MaxLimitUSD: 50000
}, {
  name: "Mexico",
  code: "MX",
  MinLimitUSD: 0,
  MaxLimitUSD: 50000
}, {
  name: "Micronesia",
  code: "FM",
  MinLimitUSD: 0,
  MaxLimitUSD: 50000
}, {
  name: "Monaco",
  code: "MC",
  MinLimitUSD: 0,
  MaxLimitUSD: 50000
}, {
  name: "Morocco",
  code: "MA",
  MinLimitUSD: 0,
  MaxLimitUSD: 50000
}, {
  name: "Nepal",
  code: "NP",
  MinLimitUSD: 0.074,
  MaxLimitUSD: 7400
}, {
  name: "Netherlands",
  code: "NL",
  MinLimitUSD: 0,
  MaxLimitUSD: 50000
}, {
  name: "New Zealand",
  code: "NZ",
  MinLimitUSD: 0.0061,
  MaxLimitUSD: 50000
}, {
  name: "Norfolk Island",
  code: "NF",
  MinLimitUSD: 0,
  MaxLimitUSD: 50000
}, {
  name: "Northern Mariana Islands",
  code: "MP",
  MinLimitUSD: 0,
  MaxLimitUSD: 50000
}, {
  name: "Norway",
  code: "NO",
  MinLimitUSD: 0,
  MaxLimitUSD: 50000
}, {
  name: "Pakistan",
  code: "PK",
  MinLimitUSD: 0.036,
  MaxLimitUSD: 3602
}, {
  name: "Peru",
  code: "PE",
  MinLimitUSD: 0,
  MaxLimitUSD: 15000
}, {
  name: "Philippines",
  code: "PH",
  MinLimitUSD: 0,
  MaxLimitUSD: 50000
}, {
  name: "Portugal",
  code: "PT",
  MinLimitUSD: 0,
  MaxLimitUSD: 50000
}, {
  name: "Puerto Rico",
  code: "PR",
  MinLimitUSD: 0,
  MaxLimitUSD: 50000
}, {
  name: "Reunion",
  code: "RE",
  MinLimitUSD: 0,
  MaxLimitUSD: 50000
}, {
  name: "Saint Barthelemy",
  code: "BL",
  MinLimitUSD: 0,
  MaxLimitUSD: 50000
}, {
  name: "Saint Martin",
  code: "MF",
  MinLimitUSD: 0,
  MaxLimitUSD: 50000
}, {
  name: "Saint Pierre and Miquelon",
  code: "PM",
  MinLimitUSD: 0,
  MaxLimitUSD: 50000
}, {
  name: "San Marino",
  code: "SM",
  MinLimitUSD: 0,
  MaxLimitUSD: 50000
}, {
  name: "Singapore",
  code: "SG",
  MinLimitUSD: 0,
  MaxLimitUSD: 50000
}, {
  name: "Slovakia",
  code: "SK",
  MinLimitUSD: 0,
  MaxLimitUSD: 50000
}, {
  name: "Slovenia",
  code: "SI",
  MinLimitUSD: 0,
  MaxLimitUSD: 50000
}, {
  name: "South Korea",
  code: "KR",
  MinLimitUSD: 0,
  MaxLimitUSD: 36697
}, {
  name: "Spain",
  code: "ES",
  MinLimitUSD: 0,
  MaxLimitUSD: 50000
}, {
  name: "Sri Lanka",
  code: "LK",
  MinLimitUSD: 0.34,
  MaxLimitUSD: 3415
}, {
  name: "Sweden",
  code: "SE",
  MinLimitUSD: 0,
  MaxLimitUSD: 50000
}, {
  name: "Switzerland",
  code: "CH",
  MinLimitUSD: 0,
  MaxLimitUSD: 50000
}, {
  name: "Tunisia",
  code: "TN",
  MinLimitUSD: 0,
  MaxLimitUSD: 32409
}, {
  name: "United Arab Emirates",
  code: "AE",
  MinLimitUSD: 4.36,
  MaxLimitUSD: 50000
}, {
  name: "United Kingdom",
  code: "GB",
  MinLimitUSD: 0,
  MaxLimitUSD: 50000
}, {
  name: "United States of America",
  code: "US",
  MinLimitUSD: 0,
  MaxLimitUSD: 50000
}, {
  name: "US Virgin Islands",
  code: "VI",
  MinLimitUSD: 0,
  MaxLimitUSD: 50000
}, {
  name: "Vatican City",
  code: "VA",
  MinLimitUSD: 0,
  MaxLimitUSD: 50000
}];

var VALID_US_STATES = exports.VALID_US_STATES = [{ label: "Alabama", value: "AL" }, { label: "Alaska", value: "AK" }, { label: "American Samoa", value: "AS" }, { label: "Arizona", value: "AZ" }, { label: "Arkansas", value: "AR" }, { label: "California", value: "CA" }, { label: "Colorado", value: "CO" }, { label: "Connecticut", value: "CT" }, { label: "Delaware", value: "DE" }, { label: "Washington, D.C.", value: "DC" }, { label: "Federated States of Micronesia", value: "FM" }, { label: "Florida", value: "FL" }, { label: "Georgia", value: "GA" }, { label: "Guam", value: "GU" }, { label: "Hawaii", value: "HI" }, { label: "Idaho", value: "ID" }, { label: "Illinois", value: "IL" }, { label: "Indiana", value: "IN" }, { label: "Iowa", value: "IA" }, { label: "Kansas", value: "KS" }, { label: "Kentucky", value: "KY" }, { label: "Louisiana", value: "LA" }, { label: "Maine", value: "ME" }, { label: "Marshall Islands", value: "MH" }, { label: "Maryland", value: "MD" }, { label: "Massachusetts", value: "MA" }, { label: "Michigan", value: "MI" }, { label: "Minnesota", value: "MN" }, { label: "Mississippi", value: "MS" }, { label: "Missouri", value: "MO" }, { label: "Montana", value: "MT" }, { label: "Nebraska", value: "NE" }, { label: "Nevada", value: "NV" }, { label: "New Hampshire", value: "NH" }, { label: "New Jersey", value: "NJ" }, { label: "New Mexico", value: "NM" }, { label: "New York", value: "NY" }, { label: "North Carolina", value: "NC" }, { label: "North Dakota", value: "ND" }, { label: "Northern Mariana Islands", value: "MP" }, { label: "Ohio", value: "OH" }, { label: "Oklahoma", value: "OK" }, { label: "Oregon", value: "OR" }, { label: "Palau", value: "PW" }, { label: "Pennsylvania", value: "PA" }, { label: "Puerto Rico", value: "PR" }, { label: "Rhode Island", value: "RI" }, { label: "South Carolina", value: "SC" }, { label: "South Dakota", value: "SD" }, { label: "Tennessee", value: "TN" }, { label: "Texas", value: "TX" }, { label: "Utah", value: "UT" }, { label: "Vermont", value: "VT" }, { label: "United States Virgin Islands", value: "VI" }, { label: "Virginia", value: "VA" }, { label: "Washington", value: "WA" }, { label: "West Virginia", value: "WV" }, { label: "Wisconsin", value: "WI" }, { label: "Wyoming", value: "WY" }, { label: "Armed Forces America", value: "AA" }, { label: "Armed Forces Pacific", value: "AP" }, { label: "Armed Forces Europe", value: "AE" }];

var VALID_SINGAPORE_STATES = exports.VALID_SINGAPORE_STATES = [{ label: "Central", value: "Central" }, { label: "East", value: "East" }, { label: "North", value: "North" }, { label: "North-East", value: "North-East" }, { label: "West", value: "West" }];


//////////////////
// WEBPACK FOOTER
// ./src/pages/ConvertPoints/hyperwallet-valid-countries.js
// module id = 1276
// module chunks = 0